'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = require('ramda');

var _formatting = require('../utils/formatting');

var _renderDeclarations = require('./renderDeclarations');

var _renderDeclarations2 = _interopRequireDefault(_renderDeclarations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderDualProps = function renderDualProps(propNames) {
  return function (_, value) {
    var directionValues = [value, value];

    return (0, _ramda.compose)(_formatting.joinWithNewline, _renderDeclarations2.default, (0, _ramda.zip)(propNames))(directionValues);
  };
};
exports.default = renderDualProps;


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/renderers/renderDualFromOneProps.js
// module id = 658
// module chunks = 168707334958949